import { render, staticRenderFns } from "./OrderPopUp.vue?vue&type=template&id=0445975b&scoped=true"
import script from "./OrderPopUp.vue?vue&type=script&lang=js"
export * from "./OrderPopUp.vue?vue&type=script&lang=js"
import style0 from "./OrderPopUp.vue?vue&type=style&index=0&id=0445975b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0445975b",
  null
  
)

export default component.exports